import { memo } from 'react';
import { Link } from 'react-router-dom';

import { Card, Descriptions } from 'antd';

import StatusIndicator from '../../../components/StatusIndicator';
import AppList from '../../../components/ui/AppList';

function TagDetails({ tag }) {
  const data = [
    {
      label: 'Kraal Tag ID',
      value: tag?.diagri_id || '/',
      isVisible: true
    },
    {
      label: 'Livestock ID',
      value: (
        <>
          {tag?.animal?.id ? (
            <Link className="underline" to={`/animals/${tag?.animal?.id}`}>
              {tag?.animal?.identifier}
            </Link>
          ) : (
            'Unlinked'
          )}
        </>
      ),
      isVisible: tag?.animal != null
    },
    {
      label: 'Battery Status',
      value: (
        <div className="d-flex align-items-center text-capitalize">
          <StatusIndicator key={tag?.id} status={tag?.battery_status} />
          {tag?.battery_status_label}
        </div>
      ),
      isVisible: true
    },
    {
      label: 'Connection Status',
      value: (
        <div className="d-flex align-items-center text-capitalize">
          <StatusIndicator key={tag?.id} status={tag?.status} />
          {tag?.status || '/'}
        </div>
      ),
      isVisible: true
    },
    {
      label: 'Connected to Gateway',
      value: (
        <>
          {tag?.gateway?.is_owner ? (
            <Link to={`/gateway/${tag?.gateway?.id}`}>{tag?.gateway?.name}</Link>
          ) : (
            <span>{tag?.gateway?.name}</span>
          )}
        </>
      ),
      isVisible: true
    }
  ];
  return (
    <Card title={`Tag ${tag?.diagri_id} details`} className="mb-2">
      <AppList>
        {data?.map(
          d =>
            d.isVisible && (
              <Descriptions.Item key={d.label} label={d.label}>
                {d.value}
              </Descriptions.Item>
            )
        )}
      </AppList>
    </Card>
  );
}

export default memo(TagDetails);
